module.exports = __webpack_public_path__ + "img/giftsshop.884ec8b4.svg";